<template>
  <NaviButtonDropdown
    class="navi-button-dropdown-links"
    :class="{ 'is-active': currentListItem ? true : false }"
    :label="props.label"
  >
    <ul>
      <li
        v-for="{ label: itemLabel, href, isActive, ...attrs } in dropdownList"
        :key="itemLabel"
      >
        <a
          v-bind="attrs"
          :href="href"
          :class="{
            'is-active': isActive
          }"
        >
          {{ itemLabel }}
        </a>
      </li>
    </ul>
  </NaviButtonDropdown>
</template>

<script setup>
import { computed } from 'vue'

import NaviButtonDropdown from './NaviButtonDropdown.vue'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  list: {
    /**
     * @example
     [
       { label: '新聞觀點', href: '/news' },
       {
         label: '新手上路',
         href: 'https://statementdog.zendesk.com/hc/zh-tw/articles/',
         target: '_blank',
         rel: 'nofollow noreferrer',
       },
       { label: '洞見', href: '/insight', isActive: ({ currentPath, listPath }) => (currentPath !== listPath) },
     ]
    */
    type: Array,
    required: true,
  },
})

const isLinkActiveValidator = ({ listPath, activeValidator }) => {
  const hasActiveValidator = typeof activeValidator === 'function'
  const currentPath = window.location.pathname

  return hasActiveValidator
    ? activeValidator({ currentPath, listPath })
    : listPath === currentPath
}

const dropdownList = computed(() => props.list.map((listItem) => {
  const {
    label, href, isActiveValidator,
    ...attrs
  } = listItem

  return {
    label,
    href,
    isActive: isLinkActiveValidator({
      listPath: href,
      activeValidator: isActiveValidator,
    }),
    ...attrs,
  }
}))
const currentListItem = computed(() => dropdownList.value.find((listItem) => listItem.isActive))
</script>

<style scoped lang="scss">
.navi-button-dropdown-links {
  :deep(.navi-button-dropdown-wrapper) {
    left: 50%;
    transform: translateX(-50%);
  }

  ul li {
    text-align: center;

    a.is-active {
      color: #0386f4;

      &:hover {
        color: #fff;
        background: #0386f4;
        text-decoration: none;
      }
    }
  }
}
</style>
